/**
 * Global store for the upgrade paywall modal.
 * Opened by the axios 402 interceptor or any billing-related error site.
 */

import { create } from 'zustand';

type BillingCode = 'NO_PLAN' | 'OUT_OF_CREDITS' | 'EXPORT_NOT_ALLOWED' | 'LENGTH_EXCEEDED' | string;

interface UpgradeModalState {
  isOpen: boolean;
  code: BillingCode | null;
  message: string | null;
  action: string | null; // "generate audio", "export video", etc.
  open: (params: { code?: BillingCode; message?: string; action?: string }) => void;
  close: () => void;
}

export const useUpgradeModal = create<UpgradeModalState>((set) => ({
  isOpen: false,
  code: null,
  message: null,
  action: null,
  open: ({ code, message, action }) =>
    set({ isOpen: true, code: code || null, message: message || null, action: action || null }),
  close: () => set({ isOpen: false, code: null, message: null, action: null }),
}));
